import { FloatingChatTabViewState } from '../store/schema/TabViewState';
import { action } from 'satcheljs/lib/legacy';

export default action('toggleChatTab')(function(viewState: FloatingChatTabViewState) {
    viewState.isChatActive = !viewState.isChatActive;
    viewState.isActive = viewState.isChatActive;
    viewState.blink = false;
});
